module.exports = __webpack_public_path__ + "img/primaria.5cc49d69.svg";